(function () {
    "use strict";

    angular.module("app").controller("SearchInstallationCertificateController", SearchInstallationCertificateController);

    SearchInstallationCertificateController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "installationCertificate", "habilDate"];
    function SearchInstallationCertificateController(controllerDecorator, infiniteScrollDataSourceFactory, installationCertificate, habilDate) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "files", "dialog"]);

        Object.defineProperty(vm, "Filter", { get: () => vm.DataSource.GetFilter() });
        Object.defineProperty(vm, "PageAndSort", { get: () => vm.DataSource.GetPageAndSort() });
        Object.defineProperty(vm, "Items", { get: () => vm.DataSource.Items() });
        
        vm.Download = download;
        vm.GetStyle = getStyle;

        initialize();

        function initialize() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(installationCertificate.Search, (v) => vm.isLoadingRequests = v);

            if (!vm.Filter.SearchMode) {
                vm.Filter.SearchMode = 0;
            }

            if (vm.PageAndSort.SortBy.length > 0) {
                vm.sortType = vm.PageAndSort.SortBy[0].Name;
                vm.sortReverse = vm.PageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "ValidUntil";
                vm.sortReverse = false;
            }

            vm.SetLoadingState(false);
        }

        function download(certificate) {
            vm.SetLoadingState(true);

            installationCertificate.Download(certificate.PublicId, vm.ShowError, () => vm.SetLoadingState(false));
        }

        function getStyle(certificate) {
            if (!certificate.ValidUntil)
                return "";

            const expiration = habilDate.GetDateOnly(certificate.ValidUntil);
            const today = habilDate.GetDateOnly(new Date());

            if (expiration.valueOf() < today.valueOf())
                return "overview-expired";

            const oneYearFromNow = habilDate.GetDateOnly(new Date()).setFullYear(today.getFullYear() + 1);
            if (expiration.valueOf() < oneYearFromNow.valueOf())
                return "overview-expiring";

            return "overview-valid";
        }
    }
})();
